import { f as r } from "./function-bind-context.js";
import { f as o } from "./function-call.js";
import { a as t } from "./a-constructor.js";
import { t as a } from "./to-object.js";
import { l as i } from "./length-of-array-like.js";
import { g as s } from "./get-iterator.js";
import { g as m } from "./get-iterator-method.js";
import { i as e } from "./is-array-iterator-method.js";
import { i as f } from "./is-big-int-array.js";
import { a as n } from "./array-buffer-view-core.js";
import { t as p } from "./to-big-int.js";
var j = n.aTypedArrayConstructor,
  c = function c(n) {
    var c,
      u,
      d,
      g,
      y,
      l,
      h,
      v,
      b = t(this),
      x = a(n),
      w = arguments.length,
      A = w > 1 ? arguments[1] : void 0,
      k = void 0 !== A,
      C = m(x);
    if (C && !e(C)) for (v = (h = s(x, C)).next, x = []; !(l = o(v, h)).done;) x.push(l.value);
    for (k && w > 2 && (A = r(A, arguments[2])), u = i(x), g = f(d = new (j(b))(u)), c = 0; u > c; c++) y = k ? A(x[c], c) : x[c], d[c] = g ? p(y) : +y;
    return d;
  };
export { c as t };